export default {
  LOCAL_SET_INSTRUMENTATIONS: (state, instrumentations) => {
    state.instrumentations = instrumentations;
  },

  LOCAL_ADD_INSTRUMENTATION: (state, instrumentation) => {
    if (Array.isArray(instrumentation)) {
      state.instrumentations.push(...instrumentation);
    } else {
      state.instrumentations.push(instrumentation);
    }
  },
  LOCAL_DELETE_INSTRUMENTATION: (state, instrumentationId) => {
    state.instrumentations = state.instrumentations.filter(
      (inst) => inst._id !== instrumentationId
    );
  },
  LOCAL_UPDATE_INSTRUMENTATION: (
    state,
    { instrumentationId, instrumentationData }
  ) => {
    const index = state.instrumentations.findIndex(
      (inst) => inst._id === instrumentationId
    );
    if (index !== -1) {
      state.instrumentations.splice(index, 1, {
        ...state.instrumentations[index],
        ...instrumentationData,
      });
    }
  },

  LOCAL_SET_INSTRUMENTATIONS_TASK: (state, instrumentationsTask) => {
    state.instrumentationsTask = instrumentationsTask;
  },
  LOCAL_SET_INSTRUMENTATION_HISTORY: (state, instrumentationHistory) => {
    state.instrumentationHistory = instrumentationHistory;
  },
  LOCAL_SET_INSTRUMENTATION_JOB_HISTORY: (state, instrumentationJobHistory) => {
    state.instrumentationJobHistory = instrumentationJobHistory;
  },

  LOCAL_SET_COUNT_BY_SITE_ID: (state, countsBySiteId) => {
    state.instrumentationCountsBySiteId = countsBySiteId;
  },
};
